// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import Vuex from 'vuex'
import VueMeta from 'vue-meta'
import VueSimpleMarkdown from 'vue-simple-markdown'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-simple-markdown/dist/vue-simple-markdown.css'

import { TablePlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './App'
import AlertAlert from 'vue-alert-alert'
import VueGtag from 'vue-gtag'

import CustomAlert from '@/components/CustomAlert.vue'

import router from './router'
import store from './store'

import {
  nFormatter,
  currencyFilterNoCents,
  currencyFilter,
  momentDateTime,
  momentDateShort,
  momentDateTimeShort,
  momentTimeShort,
} from '@/services/utils'
Vue.config.productionTip = false

Vue.use(VueMeta)
Vue.use(Vuex)
Vue.use(VueSimpleMarkdown)
Vue.component(CustomAlert.name, CustomAlert)
Vue.use(AlertAlert)
Vue.use(TablePlugin)
Vue.filter('currency', currencyFilter)
Vue.filter('currencyNoCents', currencyFilterNoCents)
Vue.filter('currencyNumSymbol', nFormatter)
Vue.filter('dateTime', momentDateTime)
Vue.filter('dateShort', momentDateShort)
Vue.filter('dateTimeShort', momentDateTimeShort)
Vue.filter('timeShort', momentTimeShort)

if (process.env.NODE_ENV == 'production') {
  Vue.use(VueGtag, {
    config: { id: 'G-N3P4FVYBYH' },
    //bootstrap:false
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
})
